import React from "react";
import { useTranslate } from "../../helpers";

const HeaderRow: React.FunctionComponent<{ text: string }> = props => {
  const t = useTranslate();

  return <h2 className="ds-h3 ds-u-padding--0">{t(props.text)}</h2>;
};

export default HeaderRow;
